import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Keynote templates are available for download to the members of the GitHub organization on `}<a parentName="p" {...{
        "href": "https://drive.google.com/file/d/1rneeYAzbt7yZrqMjkzBTNKxkNH8h24ok/view?usp=sharing"
      }}>{`Google Drive`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/10384315/56326001-35762780-6129-11e9-915d-949763cb1186.png",
        "alt": "The Keynote files"
      }}></img></p>
    <h3>{`Creating a new presentation`}</h3>
    <p>{`A new presentation can be created by opening `}<inlineCode parentName="p">{`github-presentation-template-v2020.key`}</inlineCode>{` or `}<inlineCode parentName="p">{`github-presentation-theme-v2020.kth`}</inlineCode>{`.`}</p>
    <Note variant="warning" mdxType="Note">
If you just open the regular keynote file (`.key`), you will need to duplicate this for your own presentation if you do not want to override the template for later use. It is recommended that for your first presentation you open the theme file (`.kth`) and add the theme to your Keynote to use for future use.
    </Note>
    <h3>{`Installing the Keynote theme`}</h3>
    <p>{`To install, open the theme file (`}<inlineCode parentName="p">{`.kth`}</inlineCode>{`) in Keynote and click `}<strong parentName="p">{`Add to Theme Chooser`}</strong>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/10384315/56325663-e11e7800-6127-11e9-9fd3-4291c937317d.png",
        "alt": "Add to themes"
      }}></img></p>
    <p>{`You will now have the theme available any time you open Keynote.`}</p>
    <Note mdxType="Note">
      <p>{`😕 `}<strong parentName="p">{`Having trouble?`}</strong>{` Message us in `}<a parentName="p" {...{
          "href": "https://github.slack.com/messages/C0ZCGGGJ2"
        }}>{`#design-systems`}</a>{` for assistance.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      